import React from 'react';

/**
 * Mission 10 section header — type-scale title (League Spartan) + optional
 * subtitle and a right-aligned actions slot. Use at the top of an AdminCard
 * or a page section.
 */
export interface SectionHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Right-aligned controls (buttons, filters, etc.). */
  actions?: React.ReactNode;
  /** Heading level for semantics/scale. Defaults to h2. */
  as?: 'h1' | 'h2' | 'h3';
  className?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  actions,
  as: Heading = 'h2',
  className = '',
}) => {
  const cls = ['admin-section-header', className].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      <div>
        <Heading className="admin-section-header__title">{title}</Heading>
        {subtitle ? <p className="admin-section-header__subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div>{actions}</div> : null}
    </div>
  );
};
